const manutencao_ensino_matricula = {
  path: "/manutencao-ensino-matricula",
  redirect: "/manutencao-ensino-matricula",
  meta: {
    breadCrumb: "Gerenciamento de Matrícula - Parâmetros por Município",
  },
  children: [
    {
      path: "/manutencao-ensino-matricula",
      name: "pesquisa_manutencao_ensino_matricula",
      meta: {
        allowedPermissions: ["ensino_pegar_ensino_matricula"],
      },
      component: () =>
        import(
          "@/views/ManutencaoEnsinoMatricula/PesquisaManutencaoEnsinoMatricula.vue"
        ),
    },
    {
      path: "/manutencao-ensino-matricula/:rede_ensino/:municipio?",
      name: "manutencao_ensino_matricula",
      meta: {
        allowedPermissions: ["ensino_alterar_ensino_matricula"],
      },
      component: () =>
        import(
          "@/views/ManutencaoEnsinoMatricula/ManutencaoEnsinoMatricula.vue"
        ),
    },
  ],
};

export { manutencao_ensino_matricula };
